export type RelationshipOption = {
  code: string;
  name: string;
};

// Static relationship options based on RelationshipsCollection from school-api
const RELATIONSHIP_OPTIONS: RelationshipOption[] = [
  {
    code: 'PARENT',
    name: 'Parent',
  },
  {
    code: 'GUARDIAN',
    name: 'Guardian',
  },
  {
    code: 'FRIEND',
    name: 'Friend',
  },
  {
    code: 'SPOUSE',
    name: 'Spouse',
  },
  {
    code: 'RELATIVE',
    name: 'Relative',
  },
  {
    code: 'OTHER',
    name: 'Other',
  },
];

export function useRelationshipOptions() {
  return {
    relationshipOptions: RELATIONSHIP_OPTIONS,
    isLoadingRelationshipOptions: false,
    isRelationshipOptionsError: false,
  };
}
